module.exports = __webpack_public_path__ + "socicon.60e5857089e98edd8380.eot";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/socicon/socicon.eot
// module id = ../../../../../src/assets/vendors/base/fonts/socicon/socicon.eot
// module chunks = styles